import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'reactstrap';
import Dropdown from '../Dropdown/Dropdown';
import Input from '../common/Input/Input';
import BasicTypeahead from '../common/BasicTypeahead/BasicTypeahead';
import IconButton from '../common/IconButton/IconButton';
import { BtnWrapper } from './Styled';

const operators = ["=", "!=", ">", ">=","<", "<=", "CONTAINS"];

class AttributeRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attribute: "",
            attributeIndex: 0,
            attributes: this.props.attributes,
            categories: [],
        };

    }

    componentWillReceiveProps(nextProps) {
       if (nextProps.attributeName !== this.state.attribute) {
           this.setState({attribute: nextProps.attributeName});
       }

       if (nextProps.categories !== this.state.categories) {
           this.setState({categories: nextProps.categories});
       }

    }

    handleAttributeChange = (attribute) => {
        this.setState({
            attribute: attribute,
            attributeIndex: this.props.attributeIndex
        });
        this.props.handleAttributeChange(attribute, this.props.attributeIndex);
    }

    handleOperatorChange = (operator) => {
        this.props.handleAttributeOperatorChange(operator, this.props.attributeIndex);
    }

    handleValueChange = (e) => {
        this.props.handleAttributeValueChange(e.target.value, this.props.attributeIndex);
    }

    handleDropdownValueChange = (attributeValue) => {
        this.props.handleAttributeValueChange(attributeValue, this.props.attributeIndex);
    }

    handleDeletePressed = () => {
        this.props.handleDeleteAttribute(this.props.attributeId);
    }

    render() {
        const attributeValueField = (this.state.attribute !== 'category'
            ?
            <Input
                id={`attribute-value-${this.props.attributeIndex}`}
                onChange={this.handleValueChange}
                label="Attribute value"
                maxLength="200"
                value={this.props.attributeValue}
                placeholder={this.props.attributePlaceholder}
                name="value"/>
            :
            <BasicTypeahead
                id={`attribute-value-${this.props.attributeIndex}`}
                onChange={this.handleDropdownValueChange}
                className="basicTypeahead"
                selected={[this.props.attributeValue]}
                name="value"
                label="Attribute Value"
                options={this.props.categories}/>
            );

        return (
            <Row id={this.props.id}>
                <Col xs="4">
                    <Dropdown
                        id={`attribute-type-${this.props.attributeIndex}`}
                        handleChange={this.handleAttributeChange}
                        title="Attribute Name"
                        hasOptionIcons={false}
                        selected={this.props.attributeName}
                        options={this.props.attributes} />
                </Col>
                <Col className="pl-0" xs="3">
                    <Dropdown
                        id={`attribute-operator-${this.props.attributeIndex}`}
                        handleChange={this.handleOperatorChange}
                        title="Operator"
                        hasOptionIcons={false}
                        selected={this.props.attributeClause}
                        options={operators}/>
                </Col>

                <Col className="pl-0 pr-0" xs="4">
                    {attributeValueField}
                </Col>
                <Col className="pl-0" xs="1">
                    <BtnWrapper>
                        <IconButton
                            id={`attribute-delete-button-${this.props.attributeIndex}`}
                            onClick={this.handleDeletePressed}
                            iconName='fa fa-times' />
                    </BtnWrapper>
                </Col>
            </Row>
        );
    }
};

AttributeRow.propTypes = {
    attributeIndex: PropTypes.number,
    attributePlaceholder: PropTypes.string,
    attributes: PropTypes.array,
    categories: PropTypes.array,
}

export default AttributeRow;


// WEBPACK FOOTER //
// ./src/components/AttributeRow/AttributeRow.js